import { isBefore } from 'date-fns';

import { DateValidatorParams } from './types';

export const validateDate = ({
  date,
  currentDate,
  referenceDate,
  allowPastDates,
  disabled,
  isEndDate,
}: DateValidatorParams): boolean => {
  if (disabled) return true;
  if (!allowPastDates && isBefore(date, currentDate)) return true;
  if (!referenceDate) return false;

  return isEndDate
    ? isBefore(date, referenceDate)
    : isBefore(referenceDate, date);
};

export const createDateValidators = (
  currentDate: Date,
  startDate: Date | null,
  endDate: Date | null,
  allowPastDates: boolean,
  disabled: boolean
) => ({
  shouldDisableStartDate: (date: Date) =>
    validateDate({
      date,
      currentDate,
      referenceDate: endDate,
      allowPastDates,
      disabled,
      isEndDate: false,
    }),
  shouldDisableEndDate: (date: Date) =>
    validateDate({
      date,
      currentDate,
      referenceDate: startDate,
      allowPastDates,
      disabled,
      isEndDate: true,
    }),
});
